"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _RegistrationDetails = _interopRequireDefault(require("../model/RegistrationDetails"));
var _User = _interopRequireDefault(require("../model/User"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Registration service.
* @module api/RegistrationApi
* @version 3.0
*/
var RegistrationApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new RegistrationApi. 
  * @alias module:api/RegistrationApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function RegistrationApi(apiClient) {
    _classCallCheck(this, RegistrationApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Create a User
   * Creates a User using a specific user ID. If that user ID already exists with its registration complete, an error will be returned.If the User’s registration is not yet complete, a new User will be created, removing the previous one.<br>This is used primarily when SSB clients are registering Users in the apps/portals/etc.<br>Users are considered as 'on-line' Users and must have a username + password.<br>Users belong to Customers.<br>A Customer can have multiple Users.<br>When User is created, it is linked to a Customer if it already exists or a new one is created.<br>
   * @param {Number} userId User ID
   * @param {module:model/RegistrationDetails} registrationDetails Registration Details
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/User} and HTTP response
   */
  return _createClass(RegistrationApi, [{
    key: "createUserRegistrationWithHttpInfo",
    value: function createUserRegistrationWithHttpInfo(userId, registrationDetails) {
      var postBody = registrationDetails;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling createUserRegistration");
      }
      // verify the required parameter 'registrationDetails' is set
      if (registrationDetails === undefined || registrationDetails === null) {
        throw new Error("Missing the required parameter 'registrationDetails' when calling createUserRegistration");
      }
      var pathParams = {
        'userId': userId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _User["default"];
      return this.apiClient.callApi('/users/{userId}/register', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a User
     * Creates a User using a specific user ID. If that user ID already exists with its registration complete, an error will be returned.If the User’s registration is not yet complete, a new User will be created, removing the previous one.<br>This is used primarily when SSB clients are registering Users in the apps/portals/etc.<br>Users are considered as 'on-line' Users and must have a username + password.<br>Users belong to Customers.<br>A Customer can have multiple Users.<br>When User is created, it is linked to a Customer if it already exists or a new one is created.<br>
     * @param {Number} userId User ID
     * @param {module:model/RegistrationDetails} registrationDetails Registration Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/User}
     */
  }, {
    key: "createUserRegistration",
    value: function createUserRegistration(userId, registrationDetails) {
      return this.createUserRegistrationWithHttpInfo(userId, registrationDetails).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify a User’s Registration Details
     * Modify the Registration details of a User.<br>This is used to update or complete the registration process.<br>If it is necessary if an OTP is sent out mid-registration and the User is expected to complete the process later, this method is used to do that.<br>
     * @param {Number} userId User ID
     * @param {module:model/RegistrationDetails} registrationDetails Registration Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/User} and HTTP response
     */
  }, {
    key: "modifyUserRegistrationWithHttpInfo",
    value: function modifyUserRegistrationWithHttpInfo(userId, registrationDetails) {
      var postBody = registrationDetails;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyUserRegistration");
      }
      // verify the required parameter 'registrationDetails' is set
      if (registrationDetails === undefined || registrationDetails === null) {
        throw new Error("Missing the required parameter 'registrationDetails' when calling modifyUserRegistration");
      }
      var pathParams = {
        'userId': userId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _User["default"];
      return this.apiClient.callApi('/users/{userId}/register', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify a User’s Registration Details
     * Modify the Registration details of a User.<br>This is used to update or complete the registration process.<br>If it is necessary if an OTP is sent out mid-registration and the User is expected to complete the process later, this method is used to do that.<br>
     * @param {Number} userId User ID
     * @param {module:model/RegistrationDetails} registrationDetails Registration Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/User}
     */
  }, {
    key: "modifyUserRegistration",
    value: function modifyUserRegistration(userId, registrationDetails) {
      return this.modifyUserRegistrationWithHttpInfo(userId, registrationDetails).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a User
     * Creates a User.<br>This is used primarily when SSB clients are registering Users in the apps/portals/etc.<br>Users are considered as 'on-line' Users and must have a username + password.<br>Users belong to Customers.<br>A Customer can have multiple Users.<br>When User is created, it is linked to a Customer if it already exists or a new one is created.
     * @param {module:model/RegistrationDetails} registrationDetails Registration Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/User} and HTTP response
     */
  }, {
    key: "registerUserWithHttpInfo",
    value: function registerUserWithHttpInfo(registrationDetails) {
      var postBody = registrationDetails;
      // verify the required parameter 'registrationDetails' is set
      if (registrationDetails === undefined || registrationDetails === null) {
        throw new Error("Missing the required parameter 'registrationDetails' when calling registerUser");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _User["default"];
      return this.apiClient.callApi('/users/register', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a User
     * Creates a User.<br>This is used primarily when SSB clients are registering Users in the apps/portals/etc.<br>Users are considered as 'on-line' Users and must have a username + password.<br>Users belong to Customers.<br>A Customer can have multiple Users.<br>When User is created, it is linked to a Customer if it already exists or a new one is created.
     * @param {module:model/RegistrationDetails} registrationDetails Registration Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/User}
     */
  }, {
    key: "registerUser",
    value: function registerUser(registrationDetails) {
      return this.registerUserWithHttpInfo(registrationDetails).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();